import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "pb-6 text-base leading-6 font-medium text-black" }, "Based on percentage split", -1)
const _hoisted_2 = { class: "relative w-9/12 mb-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "absolute inset-y-0 right-0 flex items-center pt-6 pr-2 text-gray-500" }, "%", -1)

import { onMounted } from "vue"
import GgmsInput from "@/components/GgmsInput.vue"
import GgmsButton from "@/components/GgmsButton.vue"
import { PlusIcon, TrashIcon } from "@heroicons/vue/outline"
import { useWorkflowStore } from "@/stores/workflow"


export default /*#__PURE__*/_defineComponent({
  __name: 'PercentageSplitComponent',
  setup(__props) {

const workflowStore = useWorkflowStore()
function addBranch() {
    workflowStore.branches.push({ value: 0, label: `Branch ${workflowStore.branches.length + 1}`, type: "percentage" })
}

function removeBranch(index: number) {
    workflowStore.branches.splice(index, 1)
    workflowStore.branches = workflowStore.branches.map((branch, index) => ({
        ...branch,
        label: `Branch ${index + 1}`,
    }))
}

onMounted(() => {
    workflowStore.areButtonDisabled = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(workflowStore).branches, (branch, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: branch.label,
        class: "flex items-center w-full gap-x-2"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(GgmsInput, {
            modelValue: branch.value,
            "onUpdate:modelValue": ($event: any) => ((branch.value) = $event),
            modelModifiers: { number: true },
            label: branch.label,
            type: "number"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]),
          _hoisted_3
        ]),
        (_unref(workflowStore).branches.length > 1)
          ? (_openBlock(), _createBlock(_unref(TrashIcon), {
              key: 0,
              class: "w-5 h-5 cursor-pointer",
              onClick: ($event: any) => (removeBranch(index))
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createVNode(GgmsButton, {
      styleType: "simple",
      "icon-start": _unref(PlusIcon),
      class: "w-fit",
      classes: ['py-0 px-0 pr-2 text-primary-color-600'],
      "icon-classes": ['fill-primary-color-600'],
      onClick: addBranch
    }, {
      default: _withCtx(() => [
        _createTextVNode("Add Branch")
      ]),
      _: 1
    }, 8, ["icon-start"])
  ], 64))
}
}

})